import React from 'react';
import Hero from '../components/why-flex/Hero'
import MeetFMS from '../UI/MeetFms'
// import StatsSection from '../components/why-flex/counter'
import WhoWeAre from '../components/why-flex/WhoWeAre'
import OurMission from '../components/why-flex/OurMission'

const WhyFlex = () => {
  return (
    <div className='w-full'>
      <Hero/>
      <WhoWeAre/>
      {/* <StatsSection/> */}
      {/* <MeetFMS/>  */}
      <OurMission/>
    </div>
  );
};

export default WhyFlex;
